import { Injectable } from '@angular/core';
import { DcBaseRequester } from '@core/dc-base.requester';
import {
	CachePolicy,
	CachePolicyEntity,
	DcBaseInitializationService,
	UrlService,
} from '@datachain/ui-sdk/common';
import { OrganizationModel } from '@dc-console-api';
import { IOrganizationModel } from '@requesters/models/organization.model';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OrganizationRequester extends DcBaseRequester<OrganizationModel> {
	protected elementsListUrl: string;
	protected resource: string;
	protected singleElementUrl: string;

	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = '';
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getOrganizationById(
		organizationId: number,
	): Observable<IOrganizationModel> {
		const endpoint = DcBaseInitializationService.getResource(
			'ORGANIZATION_BY_ID_PRIVATE_API',
		);
		const url = this.urlService.generateUrl(
			endpoint,
			{
				organizationId,
			},
			{},
		);

		const cachePolicy = CachePolicyEntity.build({
			evictTimeoutInSeconds: 60,
			isCacheable: false,
			policy: CachePolicy.NetworkOnly,
		});

		return this.get<IOrganizationModel>(url, cachePolicy);
	}
}
